module.exports = __webpack_public_path__ + "static/media/panel_logo_login.49a6bb12.svg";